import { graphql, useStaticQuery } from "gatsby";

const useLanguageQuery = () => {
  const result = useStaticQuery(graphql`
    query LanguageData {
      allDatoCmsLanguage {
        nodes {
          _allLabelLocales {
            locale
            value
          }
        }
      }
    }
  `);

  return result.allDatoCmsLanguage.nodes.map((node) => node._allLabelLocales);
};

export default useLanguageQuery;
